import type { GetAllSubscriptionsParams } from './subscriptions.types';

/**
 * Kept out of `subscriptions.store` for the same reason as `peopleKeys` — see the note
 * there.
 *
 * `serviceId` is part of every key because it is part of every request — the header
 * decides which service the response describes.
 */
export const subscriptionKeys = {
  all: ['subscriptions'] as const,
  detail: (serviceId: string) => [...subscriptionKeys.all, 'detail', serviceId] as const,
  allListAll: ['subscriptions', 'all'] as const,
  allList: (params: Partial<GetAllSubscriptionsParams>) =>
    [...subscriptionKeys.allListAll, params] as const,
  /**
   * The services the caller is billed for.
   *
   * The one key here with no `serviceId` in it, because the answer has none: `/subscriptions/all`
   * filters on the caller's `person_id` and reads the same whichever vessel's header carried
   * the request. So the list and every vessel opened from it share one cache entry — and it
   * sits under `all`, so a checkout or a plan change discards it with the rows themselves.
   */
  billed: ['subscriptions', 'billed'] as const,
  /**
   * Deliberately outside `all`: this is Stripe's price catalogue, not the caller's row. A
   * plan or seat change invalidates `all` wholesale, and it has no reason to discard prices
   * that did not move — under that prefix the pinning below would be undone by every
   * mutation on the page.
   */
  prices: (serviceId: string, lookupKeys: string[]) =>
    ['subscription-prices', serviceId, [...lookupKeys].sort()] as const,
};
